// extracted by mini-css-extract-plugin
module.exports = {"notification__wrapper":"notification__wrapper-2eSrM","notification__text":"notification__text-qsuKQ","notification__icon":"notification__icon-1s9FR"};